import { render, staticRenderFns } from "./Idioma.vue?vue&type=template&id=3e0990c2&"
import script from "./Idioma.vue?vue&type=script&lang=js&"
export * from "./Idioma.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports